import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Footer from 'src/components/Footer'
import NewHeader from 'src/New Codes/components/NewHeader'
import './PublicPages.css'
import './StaticPage.css'

const SHIPPER_POINTS = [
    'Post a shipment and open it for competitive bidding, or assign it directly at a fixed rate',
    'Compare offers from verified transporters and pick the best fit for budget and timeline',
    'Track pickup and delivery in real time, with photo and signature proof at both ends',
    'Pay through the platform wallet - funds are held until delivery is confirmed',
]

const TRANSPORTER_POINTS = [
    'Browse open loads that match your route and equipment, then bid or self-assign',
    'Manage a fleet of drivers, assign jobs and track earnings from one dashboard',
    'Get paid out once a delivery is confirmed, with a clear record of every job',
    'Fill empty return trips instead of driving back with nothing on board',
]

const STEPS = [
    { icon: 'fa-pencil-square-o', title: 'Post a load', text: 'Describe what you need moved, where from and where to.' },
    { icon: 'fa-gavel', title: 'Get bids', text: 'Verified transporters send offers - or you assign one directly.' },
    { icon: 'fa-truck', title: 'Track delivery', text: 'Follow the cargo from pickup to drop-off with proof at each end.' },
    { icon: 'fa-check-circle', title: 'Confirm & pay', text: 'Release payment from escrow once delivery is confirmed.' },
]

const TRUST = [
    { icon: 'fa-certificate', title: 'KYC-verified transporters', text: 'Every transporter passes an ID check before they can take on a job.' },
    { icon: 'fa-key', title: 'Passwordless sign-in', text: 'No password to forget or share - you sign in with a one-time code sent to your email.' },
    { icon: 'fa-lock', title: 'Escrow payments', text: 'Money is held safely until the shipper confirms the cargo arrived.' },
]

const AboutUs = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = 'About Us | Beba Mzigo'
    }, [])

    return (
        <>
            <NewHeader />
            <div className="public-page sp-page">
                <header className="sp-hero" style={{ backgroundImage: "url('/assets/images/our-services1.jpg')" }}>
                    <div className="sp-hero-overlay"></div>
                    <div className="pp-wrap sp-hero-inner">
                        <span className="sp-hero-eyebrow">About Beba Mzigo</span>
                        <h1>Connecting shippers to <span>trusted transporters</span></h1>
                        <p>
                            "Beba Mzigo" is Swahili for "carry the load" - and that's exactly what we help
                            businesses do, without owning a single truck themselves.
                        </p>
                        <div className="sp-hero-actions">
                            <Link to="/signup" className="pp-btn">Get Started</Link>
                            <Link to="/vision-mission" className="pp-btn ghost sp-btn-light">Our Vision</Link>
                        </div>
                    </div>
                </header>

                <div className="pp-wrap sp-stats-band">
                    <div className="sp-stats">
                        <div className="sp-stat"><strong>380,000+</strong><span>Parcels shipped safely</span></div>
                        <div className="sp-stat"><strong>KYC-verified</strong><span>Every transporter ID-checked</span></div>
                        <div className="sp-stat"><strong>Escrow</strong><span>Secure held payments</span></div>
                    </div>
                </div>

                <section className="pp-wrap sp-split">
                    <div className="sp-split-text">
                        <span className="sp-kicker">Who we are</span>
                        <h2>One marketplace for everyone who moves cargo</h2>
                        <p>
                            Beba Mzigo is a logistics platform that connects <strong>Shippers</strong> -
                            businesses and individuals who need to move goods - with <strong>verified Transporters</strong> who
                            have the trucks, vans and drivers to move them.
                        </p>
                        <p>
                            We started because moving cargo was too often a matter of who you happened to know.
                            A shipper without a network of truck owners would overpay or wait days for a lead, while a
                            transporter would drive back empty instead of picking up a paying load. We built Beba Mzigo to
                            fix that mismatch with technology.
                        </p>
                    </div>
                    <div className="sp-split-media">
                        <img src="/assets/images/black-man-delivery.png" alt="A Beba Mzigo courier handing over a parcel at the door" />
                    </div>
                </section>

                <section className="sp-band">
                    <div className="pp-wrap">
                        <div className="sp-section-head">
                            <span className="sp-kicker">What we do</span>
                            <h2>Built for both sides of the load</h2>
                        </div>
                        <div className="sp-audience">
                            <div className="sp-audience-card">
                                <div className="sp-audience-icon"><i className="fa fa-cube"></i></div>
                                <h3>For shippers</h3>
                                <ul>
                                    {SHIPPER_POINTS.map((p) => <li key={p}><i className="fa fa-check"></i><span>{p}</span></li>)}
                                </ul>
                            </div>
                            <div className="sp-audience-card dark">
                                <div className="sp-audience-icon"><i className="fa fa-truck"></i></div>
                                <h3>For transporters</h3>
                                <ul>
                                    {TRANSPORTER_POINTS.map((p) => <li key={p}><i className="fa fa-check"></i><span>{p}</span></li>)}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="pp-wrap sp-steps-section">
                    <div className="sp-section-head">
                        <span className="sp-kicker">How it works</span>
                        <h2>From posting to paid in four steps</h2>
                    </div>
                    <div className="sp-steps">
                        {STEPS.map((step, i) => (
                            <div className="sp-step" key={step.title}>
                                <div className="sp-step-num">{i + 1}</div>
                                <div className="sp-step-icon"><i className={`fa ${step.icon}`}></i></div>
                                <h3>{step.title}</h3>
                                <p>{step.text}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="sp-band">
                    <div className="pp-wrap">
                        <div className="sp-section-head">
                            <span className="sp-kicker">Trust</span>
                            <h2>Built on verification, not just contacts</h2>
                        </div>
                        <div className="sp-trust">
                            {TRUST.map((item) => (
                                <div className="sp-trust-item" key={item.title}>
                                    <div className="sp-trust-icon"><i className={`fa ${item.icon}`}></i></div>
                                    <div>
                                        <h3>{item.title}</h3>
                                        <p>{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="pp-wrap">
                    <div className="sp-cta">
                        <div>
                            <h3>Ready to move your next load?</h3>
                            <p>Sign up as a shipper to post your first job, or as a transporter to start bidding.</p>
                        </div>
                        <Link to="/signup" className="pp-btn">Get Started</Link>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    )
}

export default AboutUs
